export const demoHref = 'https://school.ucheba.ru/demo'

export const footerNavSchoolLinks = [
  {
    name: 'Публичная оферта',
    href: 'https://ucheba.ru/pix/static/dogovor-offeri-11.02.2025.pdf',
  },
  {
    name: '<a href="tel:+74994505799" style="display: inline-block">+7 499 450-57-99</a>',
  },
]

export const chatTemplateId = 10067
